import { render, staticRenderFns } from "./filterConfigModal.vue?vue&type=template&id=13aff842&scoped=true"
import script from "./filterConfigModal.vue?vue&type=script&lang=js"
export * from "./filterConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aff842",
  null
  
)

export default component.exports